import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts/UserContext";
import LoadingLogo from "../components/LoadingLogo";
import "./style/Success.css";

const endpoint = process.env.REACT_APP_API_URL + "/check-stripe-cagnotte-session";

function SuccessCagnotte() {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const { tokens } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    const session_id = params.get("session_id");
    if (!session_id) {
      setError("Aucune session Stripe détectée");
      setLoading(false);
      return;
    }
    if (!tokens?.accessToken) return;

    setLoading(true);
    axios
      .get(`${endpoint}?session_id=${session_id}`, {
        headers: {
          Authorization: `Bearer ${tokens.accessToken}`,
        },
      })
      .then((res) => {
        setStatus(res.data.status);
      })
      .catch(() => {
        setError("Erreur lors de la validation du paiement cagnotte");
      })
      .finally(() => setLoading(false));
  }, [params, tokens]);

  // Loader
  if (!tokens?.accessToken || loading) {
    return (
      <div className="success-loader-center">
        <LoadingLogo />
      </div>
    );
  }

  // Message d'erreur
  if (error) {
    return (
      <div className="success-upload-container">
        <div className="success-msg error">
          <span role="img" aria-label="erreur" style={{ fontSize: 34 }}>❌</span>
          <br />
          {error}
        </div>
      </div>
    );
  }

  // Succès : Cagnotte activée
  if (status === "paid") {
    return (
      <div className="success-upload-container">
        <div className="success-msg success">
          <span role="img" aria-label="success" style={{ fontSize: 40, color: "#facc15" }}>🎉</span>
          <br />
          <span style={{ color: "#facc15", fontWeight: 600, fontSize: "1.27rem" }}>
            Cagnotte activée avec succès !
          </span>
          <div style={{ marginTop: 30 }}>
            <div style={{
              color: "#fff",
              fontSize: "1.08rem",
              marginBottom: 12,
              fontWeight: 500,
            }}>
              Vous pouvez maintenant recevoir des dons sur cet évènement.
            </div>
            <button
              className="btn btn-create-event"
              style={{
                background: "linear-gradient(90deg, #facc15 70%, #ffe98a 100%)",
                color: "#332d03",
                fontWeight: 700,
                border: "none",
                borderRadius: 999,
                padding: "13px 32px",
                fontSize: "1.11rem",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(251,202,21,0.15)"
              }}
              onClick={() => navigate("/events")}
            >
              Voir mes évènements
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Statut non payé
  return (
    <div className="success-upload-container">
      <div className="success-msg info">
        Paiement non validé ou en attente.<br />
        Statut : <b>{status}</b>
      </div>
    </div>
  );
}

export default SuccessCagnotte;
